import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface MalvernStarBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

/**
 * The supplied artwork is a 566.93 square whose star fills ~90% of the box,
 * where the other brand marks fill ~71% of theirs. The padded viewBox keeps the
 * star centred on (283.48, 283.48) while scaling it down to match.
 */
function MalvernStarBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="-75.5 -75.5 718 718"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Malvern Star</title>
      <path
        d="M410.88,283.52l73.1-99.83,20.22-27.6-34.05,3.73-122.89,13.36-49.95-113.23-13.77-31.3-13.8,31.3-49.94,113.19-122.92-13.45-34.06-3.76,20.24,27.62,73,99.88-73.06,99.84-20.25,27.6,34.06-3.74,122.93-13.36,49.86,113.25,13.76,31.29,13.81-31.27,50.03-113.23,122.86,13.45,34.06,3.76-20.2-27.62-73.02-99.88ZM381.21,332.18l9.85,13.48-16.6-1.83-59.92-6.57-24.39,55.21-6.73,15.26-6.73-15.26-24.31-55.22-59.94,6.51-16.6,1.82,9.86-13.47,35.64-48.67-35.59-48.7-9.87-13.47,16.6,1.82,59.94,6.57,24.37-55.21,6.72-15.25,6.72,15.26,24.35,55.22,59.93-6.51,16.61-1.82-9.86,13.47-35.66,48.67,35.61,48.69Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconMalvernStarBrand(props: MalvernStarBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <MalvernStarBrandSvg
        className={props.className}
        variant={props.variant}
      />
    </IconWrapper>
  );
}
